<template>
  <DialogHeader>
    <template #right>
      <div
        class="font-medium text-green-900 cursor-pointer"
        @click="handleClick"
      >
        Continue
      </div>
    </template>
    Resubscribe to Dacr {{ billingStore.billing?.plan.name }}
  </DialogHeader>
  <DialogContent>
    <template v-if="hasOutsandingBalance">
      <div class="mb-2">
        Your subscription ended and your account balance has
        <span class="font-bold">accrued {{ outstandingBalance }}</span> since
        that time. You can learn more about your account balance by reviewing
        your
        <span
          class="text-green-900 font-semibold font-primary"
          @click="handleLinkClick"
        >
          past invoices
        </span>
        .
      </div>
      <div class="mb-2">
        If you wish to resubscribe you will be charged the remaining balance.
      </div>
      <div>You will confirm your payment in the next step.</div>
    </template>
    <div v-else>
      <div class="mb-2">Your subscription was previously canceled.</div>
      <div>
        To resubscribe, you must confirm your payment method in the next step
      </div>
    </div>
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-1/2 tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton class="w-1/2 tablet-h:w-auto" primary @click="handleClick">
      Yes, continue
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import { computed } from 'vue'
import { formatPrice } from '@/shared/utils/money'
import { useRouter } from 'vue-router'
import { useBillingStore } from '@/features/billing/store'

const { close, open } = useDialog()

const router = useRouter()
const billingStore = useBillingStore()

const hasOutsandingBalance = computed(() =>
  billingStore.billing?.upcomingDetails.upcomingBilling?.breakdown.some(
    (breakdown) => breakdown.outstanding
  )
)

const outstandingBalance = computed(() => {
  const totalOutstanding =
    billingStore.billing?.upcomingDetails.upcomingBilling?.breakdown.reduce(
      (acc, breakdown) =>
        (acc += breakdown.outstanding ? breakdown.amount || 0 : 0),
      0
    ) || 0

  return formatPrice({
    amount: totalOutstanding / 100,
    currency: billingStore.billing?.upcomingDetails.upcomingBilling?.currency,
  })
})

const handleLinkClick = () => {
  router.push('/settings/billing')
  close()
}

const handleClick = () => {
  open(Dialogs.ConfirmPaymentMethod)
}
</script>
